import { FC, useMemo } from 'react';
import { IMultiLanguageTextAreaLengthProps } from '../../types';

const MultiLanguageTextAreaLength: FC<IMultiLanguageTextAreaLengthProps> = (props: IMultiLanguageTextAreaLengthProps): JSX.Element | null => {
  const areaLength = useMemo((): string | null => {
    if (!props.showLength || (!props.value.length && !props.maxLength)) return null;
    return String(props.value.length) + (props.maxLength ? `/${String(props.maxLength)}` : '');
  }, [props]);

  if (!areaLength) return null;

  return <p className="family-medium text-size-14 color-gray2 font-weight-500 mt-2">{areaLength}</p>;
};

export default MultiLanguageTextAreaLength;
